var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-with-label"},[_c('span',{staticClass:"input-with-label__label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }